import styled, { css } from 'styled-components';

import { ReactComponent as ClockIcon } from '../../../../../assets/images/blueTheme/clock.svg';
import { ReactComponent as DownloadIcon } from '../../../../../assets/images/blueTheme/download.svg';
import { BlueButton, OutlineButton } from '../../../../../components/BlueTheme/Buttons/styled';

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: InspireTWDC;
`;

export const ScheduleButton = styled(OutlineButton)`
  height: 32px;

  span {
    display: flex;
    align-items: center;
  }
`;

export const ExportButton = styled(BlueButton)(
  ({ theme: { spacers, admanColors } }) => css`
    position: relative;
    height: 32px;
    white-space: nowrap;
    padding: 0 ${spacers!.spacer02};

    svg {
      fill: ${admanColors!.gray.light.bg0[0]};
    }

    span {
      display: flex;
      align-items: center;
    }

    ul {
      bottom: -9px;
    }
  `
);

export const ClockIconWrapper = styled(ClockIcon)`
  width: 15px;
  height: 15px;
  margin-right: ${({ theme: { spacers } }): string => `${spacers!.spacer02}`};
`;

export const DownloadIconWrapper = styled(DownloadIcon)`
  width: 15px;
  height: 15px;
  margin-right: ${({ theme: { spacers } }): string => `${spacers!.spacer02}`};
`;

export const ReportHeader = styled.div(
  ({ theme: { spacers } }) => css`
    padding: ${spacers!.spacer04} ${spacers!.spacer04} ${spacers!.spacer02} ${spacers!.spacer04};
    font-family: InspireTWDC;
  `
);
export const ReportInfoAndActions = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ReportInfo = styled.div`
  width: 75%;
  margin-right: ${({ theme: { spacers } }): string => `${spacers!.spacer07}`};
`;

export const ReportName = styled.div`
  font-size: 18px;
  line-height: 21px;
  font-weight: 600;
  color: ${({ theme }): string => theme.admanColors!.gray.dark.bg3[0]};
`;

export const ReportDescription = styled.div(
  ({ theme: { spacers, admanColors } }) => css`
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    color: ${admanColors!.gray.light.fg1[1]};
    margin-top: ${spacers!.spacer01};
  `
);

export const ReportActions = styled.div`
  display: flex;
  gap: ${({ theme }): string => theme.spacers!.spacer03};
`;

export const ReportFilters = styled.div`
  margin-top: ${({ theme }): string => theme.spacers!.spacer02};
  display: flex;
`;
